module.exports = __webpack_public_path__ + "static/media/MytheRite.e043d2f9.jpg";